import { LifecyclePhase, type LifecycleHook } from '@tundr/lifecycle-hooks';
import { useModalStore } from './store/modal.store';

export const modalResetOp: LifecycleHook = {
  name: 'modal:reset',
  fn: () => useModalStore().closeModal(),
  phases: [
    { phase: LifecyclePhase.APP_LAUNCH },
    { phase: LifecyclePhase.LOGOUT },
  ],
};
